export const fetchSecaoOptions = async () => [
  { key: 'Seção 1', value: 'Seção 1 - Atos do normativo' },
  { key: 'Seção 2', value: 'Seção 2 - Atos do pessoal' },
  { key: 'Seção 3', value: 'Seção 3 - Atos do executivo' },
]
